/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Current_PlanInputs */

const en_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Plan`)
};

const de_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Plan`)
};

const fr_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actuel`)
};

const es_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan actual`)
};

const it_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piano attuale`)
};

const nl_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidig abonnement`)
};

const pl_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecny plan`)
};

const fi_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyinen tilaus`)
};

const da_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuværende plan`)
};

const sv_pricing_current_plan = /** @type {(inputs: Pricing_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuvarande plan`)
};

/**
* | output |
* | --- |
* | "Current Plan" |
*
* @param {Pricing_Current_PlanInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_current_plan = /** @type {((inputs?: Pricing_Current_PlanInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Current_PlanInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_current_plan(inputs)
	if (locale === "fr") return fr_pricing_current_plan(inputs)
	if (locale === "es") return es_pricing_current_plan(inputs)
	if (locale === "it") return it_pricing_current_plan(inputs)
	if (locale === "nl") return nl_pricing_current_plan(inputs)
	if (locale === "pl") return pl_pricing_current_plan(inputs)
	if (locale === "fi") return fi_pricing_current_plan(inputs)
	if (locale === "da") return da_pricing_current_plan(inputs)
	if (locale === "sv") return sv_pricing_current_plan(inputs)
	return en_pricing_current_plan(inputs)
});